<template>
  <div id="app">
    <async-layout />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AsyncLoading from '@app/core/AsyncLoading';
import AsyncError from '@app/core/AsyncError';

export default {
  name: 'App',
  components: {
    AsyncLayout: () => ({
      component: import(/* webpackChunkName: "ui" */'@ui/layouts/LayoutLoan'),
      // A component to use while the async component is loading
      loading: AsyncLoading,
      // A component to use if the load fails
      error: AsyncError,
      // Delay before showing the loading component. Default: 200ms.
      delay: 0,
      // The error component will be displayed if a timeout is
      // provided and exceeded. Default: Infinity.
      timeout: 50000
    })
  },
  props: {
    externalHandler: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters([
      'getUserInput',
      'getUpdateCount'
    ])
  },
  watch: {
    getUpdateCount() {
      this.updateTotal();
    }
  },
  methods: {
    ...mapActions([
      'setTotal',
      'setRate',
      'setSecondYearRate',
      'setSecondYearTotal'
    ]),
    updateTotal() {
      const output = this.externalHandler(this.getUserInput);
      const firstYearMonths = 12;
      const secondYearMonths = firstYearMonths + 1;

      if (!output.success) {
        throw output.result.error;
      }

      // for debug in test/product env
      if(window.$rbcalcDebug) {
        console.log(output);
      }

      this.setTotal(Math.floor(output.result.grid[firstYearMonths].paymentMonthly));
      this.setRate((output.result.grid[firstYearMonths].rate * 100).toFixed(2));

      this.setSecondYearTotal(Math.floor(output.result.grid[secondYearMonths].paymentMonthly));
      this.setSecondYearRate(output.result.grid[secondYearMonths].rate * 100);
    }
  }
};
</script>
